__turbopack_context__.v({
  "className": "noto_color_emoji_70d90d24-module__EdpQJG__className",
});
